import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=23841959&"
import script from "./amenities.vue?vue&type=script&lang=js&"
export * from "./amenities.vue?vue&type=script&lang=js&"
import style0 from "./amenities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "amenities.vue"
export default component.exports